import { render, staticRenderFns } from "./ClientSettingGame.vue?vue&type=template&id=0fbd6dca&"
import script from "./ClientSettingGame.vue?vue&type=script&lang=js&"
export * from "./ClientSettingGame.vue?vue&type=script&lang=js&"
import style0 from "./ClientSettingGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VFlex,VIcon,VLayout,VProgressCircular,VSelect,VSwitch,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbd6dca')) {
      api.createRecord('0fbd6dca', component.options)
    } else {
      api.reload('0fbd6dca', component.options)
    }
    module.hot.accept("./ClientSettingGame.vue?vue&type=template&id=0fbd6dca&", function () {
      api.rerender('0fbd6dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Game/ClientSettingGame.vue"
export default component.exports